import moment from 'moment';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-main p-1">
        &#169; Copyright Gloify {moment().year()} | All Right Reserved |&nbsp;
        <a href="privacy-policy">Privacy Policy</a>&nbsp;|&nbsp;
        <a href="terms-and-conditions">Terms and Conditions</a>
      </div>
    </footer>
  );
};

export default Footer;
